/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsRespiratorV1: {
  name: 'respirator-v1';
  data: string;
} = {
  name: 'respirator-v1',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 2.867A2.367 2.367 0 0 1 2.867.5H13.133A2.367 2.367 0 0 1 15.5 2.867V8a7.5 7.5 0 0 1-15 0V2.867Zm12-1.367h-9v2h9v-2Zm-10 .05V4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V1.55c.577.16 1 .689 1 1.317V8a6.5 6.5 0 1 1-13 0V2.867c0-.628.423-1.157 1-1.317ZM5.5 9a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM8 5.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM8 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
